import Staff from "./staff/staff_leave.store";
import Teacher from "./teacher/teacher_leave.store";

export default {
  modules: { Staff, Teacher },
};
